module.exports = __webpack_public_path__ + "c3a0ade90d212ba90cfac2e8b26952cf.gif";